import { actionFactory } from "./actionUtils";

export const setClientMode = actionFactory("SET_CLIENT_MODE");

export const setTheme = actionFactory("SET_THEME");